// сделан по аналогии с react-use

import { useEffect, useState } from 'react';

export function useObjectUrl(file: Blob | MediaSource | null | undefined) {
  const [link, setLink] = useState<string>();

  useEffect(() => {
    if (!file) {
      setLink(undefined);

      return;
    }

    const objectLink = URL.createObjectURL(file);
    setLink(objectLink);

    return () => {
      URL.revokeObjectURL(objectLink);
      setLink(undefined);
    };
  }, [file]);

  return link;
}
